<template>
  <router-link to="/"
    ><img
      class="img-fluid for-light"
      src="@/assets/images/logo-SK.png"
      alt=""
      style="width:10rem"
  /></router-link>
</template>